import React from 'react'
import { useProjectContext } from '../../context/ProjectContext'

const LoopHeightTool = ({ onClose = null }) => {
  const { selectedLoopHeight, setSelectedLoopHeight } = useProjectContext()

  const heights = [
    { value: 'none', label: 'X' },
    { value: 'low', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
  ]

  const handleSelect = (value) => {
    setSelectedLoopHeight(value)
    if (onClose) onClose()
  }

  return (
    <>
      {heights.map((height) => (
        <button
          key={height.value}
          type="button"
          className={selectedLoopHeight === height.value ? 'active' : ''}
          onClick={() => handleSelect(height.value)}
          title={height.label}
        >
          {height.label}
        </button>
      ))}
    </>
  )
}

export default LoopHeightTool